import './App.scss';
import { Clock } from './Clock/Clock';


export const App = () => (
  <div className="App">
    <Clock />
    <div className="note">Need For Speed? Click on the spinning clock to reveal all. Click on the seconds if you're a nerd.</div>
  </div>
);